/**
 * Der BauKlotzBude-Shop hat seit Oktober 2026 eine eigene Domain.
 *
 * Alles auf www.weretrade.com, was zum Shop fuehrt, liest die Adresse von hier:
 * Navigation, Verweise in den Seiten, die SPA-Route /shop/* und die
 * Weiterleitung der alten Adressen in functions/shop/[[path]].ts. Ziehen die
 * Domain oder der Pfad noch einmal um, aendert sich genau diese Datei.
 */
export const BKB_SHOP_ORIGIN = 'https://bauklotzbude.de';
export const BKB_SHOP_URL = `${BKB_SHOP_ORIGIN}/shop`;

/**
 * Antwortet mit 200 und JSON (`{"status":"ok",...}`). Unter /api/shop/health
 * liefert bauklotzbude.de dagegen die Shop-SPA als HTML aus.
 */
export const BKB_SHOP_HEALTH_URL = `${BKB_SHOP_ORIGIN}/shop-api/health`;

/**
 * Diese Dateien liefert der Shop an der Wurzel der Domain aus, nicht unter
 * /shop. Unter bauklotzbude.de/shop/sitemap.xml antwortet die SPA mit HTML.
 */
const ROOT_LEVEL_FILES = new Set(['sitemap.xml', 'robots.txt', 'feed.xml', 'google-shopping-feed.xml']);

/**
 * Bildet eine alte Shop-Adresse von www.weretrade.com auf ihr Ziel auf
 * bauklotzbude.de ab. `search` ist `URL.search` bzw. `location.search` und
 * wird unveraendert angehaengt: bereits versendete Bestellmails verlinken
 * /shop/order/<id>?access=<token>.
 *
 *   /shop, /shop/                 -> https://bauklotzbude.de/shop
 *   /shop/product/<slug>/         -> https://bauklotzbude.de/shop/product/<slug>
 *   /shop/sitemap.xml (+ robots.txt, feed.xml, google-shopping-feed.xml)
 *                                 -> https://bauklotzbude.de/sitemap.xml
 *
 * Das Ziel bleibt immer auf BKB_SHOP_ORIGIN; der Pfad kann den Host nicht
 * wechseln, weil er erst hinter "/shop/" bzw. aus einer festen Liste kommt.
 */
export function bkbShopUrlFor(pathname: string, search = ''): string {
  const rest = pathname.replace(/^\/shop(?=\/|$)/, '').replace(/^\/+|\/+$/g, '');

  let target = BKB_SHOP_URL;
  if (ROOT_LEVEL_FILES.has(rest)) {
    target = `${BKB_SHOP_ORIGIN}/${rest}`;
  } else if (rest !== '') {
    target = `${BKB_SHOP_URL}/${rest}`;
  }

  return `${target}${search}`;
}
